module.exports = __webpack_public_path__ + "img/img-btnBg@2x.318f168e.png";